import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';

import * as _ from 'underscore';

// Service
import { PercentageofbreakListService } from '../../service/percentageofbreak-list/percentageofbreak-list.service';

@Component({
	selector: 'app-percentageofbreak-list',
	templateUrl: './percentageofbreak-list.component.html',
	providers: [
		PercentageofbreakListService,
		HttpModule
	]
})
export class PercentageofbreakListComponent implements OnInit {

	private token;
	public percents: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "Porcentagem";
	public sort: string = "asc";
	public permissoes: any[] = [];
	currentPage: number = 0;
	percForm: FormGroup;

	constructor(fb: FormBuilder, private percentageofbreakListService: PercentageofbreakListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.percForm = fb.group({
			'Porcentagem': '',
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.searchPercent(this.percForm.value, 0, false);
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc"; 
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchPercent(this.percForm.value, this.currentPage, false);
	}

	searchPercent(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Porcentagem";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.percentageofbreakListService.searchPercent(this.token, value.Porcentagem, value.Ativo, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.percents = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		})
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchPercent(this.percForm.value, $event, false);
	}

}



// WEBPACK FOOTER //
// ./src/app/percentageofbreak/component/percentageofbreak-list/percentageofbreak-list.component.ts